<template>
  <v-row>
    <v-col cols="12" md="12" class="py-1 font-weight-bold">
      Notes:
    </v-col>
    <v-col cols="12" md="12" class="py-2" v-for="(note, k) in notes" :key="'key-' + k">
      <v-row>
        <v-col cols="12" md="8" class="py-0">
          {{note.note}}
        </v-col>
        <v-col cols="12" md="4" class="py-0">
          <v-chip label small v-if="note.user && note.user.name">{{note.user.name}}</v-chip>
          <v-chip label small v-else>NEW</v-chip>
          <v-btn color="error" class="mx-1" x-small @click="removeNote(note)" v-if="!note.user">Remove Note</v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="8" class="py-1">
      <v-text-field label="Note" v-model="new_note" outlined hide-details dense name='newNote'></v-text-field>
    </v-col>
    <v-col cols="12" md="4" class="py-1">
      <v-btn color="primary" small @click="addNote()">Add Note</v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props:['resource', 'notes'],
  data(){
    return {
      new_note:null,
    }
  },
  methods:{
    async addNote() {
      if(!this.new_note || !this.resource.id) return true;
      const data = {
        new_lead_id:this.resource.id,
        note:this.new_note
      }
      this.$emit('newNote', data)
    },
    async removeNote(note) {
      this.$emit('removeNote', note)
    }
  }
}
</script>

<style>

</style>